export default __webpack_public_path__ + "static/use-case-1.url-9213650db9f667167eca67b9b75ccd18.svg";